import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import { lessonFeatureKey, lessonReducer } from "../internal/store/lesson-reducer";
import { EffectsModule } from "@ngrx/effects";
import { ConnectToClassroomEffects } from "../internal/effects/connect-to-classroom.effects";
import { ClassroomConsumerEffects } from "../internal/effects/classroom-consumer.effects";
import { ClassroomSyncConsumerEffects } from "../internal/effects/classroom-sync-consumer.effects";
import { ClassroomSignalrEmitterEffects } from "../internal/effects/classroom-signalr-emitter.effects";
import { ConnectionFailedNotificationEffects } from "../internal/effects/connection-failed-notification.effects";
import { ScreenWakeLockEffects } from "../internal/effects/screen-wake-lock.effects";
import { LessonYjsLifecycleEffects } from "../internal/effects/lesson-yjs-lifecycle.effects";
import { LessonYjsMirrorEffects } from "../internal/effects/lesson-yjs-mirror.effects";
import { ClassroomResetEffects } from "../internal/effects/classroom-reset.effects";
import { ClassroomLifecycleEffects } from "../internal/effects/classroom-lifecycle.effects";
import { provideSharedClassroomNotificationsConfig } from "./notification.tokens";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(lessonFeatureKey, lessonReducer),
        EffectsModule.forFeature([
            ConnectToClassroomEffects,
            ClassroomConsumerEffects,

            // `StartLessonEffects` (PCP + TUT teacher) and `LiveLessonEffects`
            // (PCP teacher only) are NOT registered here — only teacher apps
            // dispatch their triggering actions. They are opted in per app via
            // `provideStartLessonEffects()` / `provideLiveLessonEffects()` in the
            // preview-screen feature-shell factory methods.
            ClassroomSyncConsumerEffects,
            ClassroomSignalrEmitterEffects,
            ConnectionFailedNotificationEffects,
            ScreenWakeLockEffects,
            LessonYjsLifecycleEffects,
            LessonYjsMirrorEffects,

            // Owns the Y.Doc write for the same-slide reset gesture
            // (reacts to `ClassroomEvents.userResetActiveSlide`). Always
            // registered: the action only dispatches teacher-side, so the
            // effect is inert elsewhere and `guardWrite()` covers the write.
            ClassroomResetEffects,

            // Owns every dispatch of `classroomLifecycleEvents.lessonHasBeenStopped`
            // (local stop-flow relay + other-teacher-client SignalR notification).
            // Always registered: both triggers only fire teacher-side, so the
            // effects are inert elsewhere.
            ClassroomLifecycleEffects,
        ]),
    ],
    providers: [
        provideSharedClassroomNotificationsConfig({ showSnackbarOnJoinLessonFailure: true }),
    ],
})
export class SharedClassroomDataAccessModule {}
